import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { List, FileText } from 'lucide-react';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import LeaveTypes from './LeaveTypes';
import LeavePolicies from './LeavePolicies';

export default function LeaveConfiguration() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from URL
  const getActiveTabFromUrl = () => {
    const path = location.pathname;
    if (path.includes('/policies')) return 'policies';
    if (path.includes('/types')) return 'types';
    return 'types'; // default
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());

  // Update active tab when URL changes
  useEffect(() => {
    setActiveTab(getActiveTabFromUrl());
  }, [location.pathname]);

  const tabs = [
    { id: 'types', label: 'Leave Types', icon: List, path: '/hrm/leave/types' },
    { id: 'policies', label: 'Leave Policies', icon: FileText, path: '/hrm/leave/policies' },
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  // Render the active component
  const renderActiveComponent = () => {
    switch(activeTab) {
      case 'types':
        return <LeaveTypes />;
      case 'policies':
        return <LeavePolicies />;
      default:
        return <LeaveTypes />;
    }
  };

  return (
    <div className="p-6 space-y-4">
      {/* ── Header ─────────────────────────────────────────────── */}
      <Breadcrumb
        trail={['HRM', 'Leave Configuration']}
        title="Leave Configuration"
        subtitle="Manage leave types and policies for your organization."
      />

      {/* ── Tabs Navigation ────────────────────────────────────────── */}
      <div>
        <div className="border-b border-gray-200">
          <nav className="flex space-x-4 overflow-x-auto" aria-label="Tabs">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab)}
                  className={`
                    flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-all whitespace-nowrap
                    ${isActive 
                      ? 'border-primary-600 text-primary-700' 
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                >
                  <tab.icon size={18} className={isActive ? 'text-primary-600' : 'text-gray-400'} />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* ── Tab Content ────────────────────────────────────────────── */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="p-0">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
}